
// Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import { postFakeProfile, postJwtProfile } from "../../../helpers/fakebackend_helper";
import axios from "axios";
import { fetchAuthSession } from 'aws-amplify/auth';

// Action imports
import { profileSuccess, profileError, resetProfileFlagChange, setProfileData } from "./reducer";

const fireBaseBackend = getFirebaseBackend();

export const editProfile = (user) => async (dispatch) => {
    try {
        let response;

        if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
            response = fireBaseBackend.editProfileAPI(
                user.username,
                user.idx
            );
        }
        else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
            response = postJwtProfile({
                username: user.username,
                idx: user.idx,
            });
        }
        // Fake backend for testing purposes
        else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
            response = postFakeProfile(user);
        }

        const data = await response;

        if (data) {
            dispatch(profileSuccess(data)); // Dispatch the profile success action
        }
    } catch (error) {
        dispatch(profileError(error.message)); // Dispatch error message if any issue occurs
    }
};

// Fetch profile data action
export const profiledata = (id) => async (dispatch) => {
    const token = localStorage.getItem('token');
    // console.log("id", id);

    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/profile/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        // console.log(response);

        if (response) {
            dispatch(setProfileData(response)); // Dispatch profile data to the reducer
        }
    } catch (error) {
        console.error("Error fetching profile:", error);

    }
};

const handleSessionExpiration = () => {
    localStorage.clear();
    window.location.href = '/login'; // Redirect to the sign-in page
};

// Reset profile success/error flag
export const resetProfileFlag = () => (dispatch) => {
    try {
        dispatch(resetProfileFlagChange()); // Reset flags
    } catch (error) {
        console.error("Error resetting profile flag:", error);
    }
};
